// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const PartnerOut = zod.object({
  "id": zod.uuid(),
  "name": zod.string()
});

export type PartnerOut = zod.input<typeof PartnerOut>;
export type PartnerOutOutput = zod.output<typeof PartnerOut>;
